import { enqueueSnackbar } from 'notistack';
import { handleErrors } from '../../../utils/functions';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import {
    useCompleteUploadFileMutation,
    useUploadDocumentDataFormMutation
} from '../../../services/documentsApi';

function useUpload() {
    const navigate = useNavigate();
    const [uploadingDocument, setUploadingDocument] = useState<boolean>(false);
    const [uploadDocumentDataForm] = useUploadDocumentDataFormMutation();
    const [completeUploadFile] = useCompleteUploadFileMutation();

    function fileChunker(file: any, chunkSize = 1024 * 1024 * 10) {
        // mínimo chunkSize es 10MB
        if (file?.size < chunkSize) chunkSize = file?.size;

        let chunks: any = [];
        let count = Math.ceil(file?.size / chunkSize);

        for (let i = 0; i < count; i++) {
            let start = i * chunkSize;
            let end = start + chunkSize;
            chunks.push(file?.slice(start, end));
        }

        return chunks;
    }

    const getIdFileExtension = (data: any) => {
        if (!data?.selectedFile) return;
        return data?.tipoDocumento?.tiposArchivo.find(
            (item: any) => item.tipo === data?.selectedFile?.type
        )?.id;
    };

    const handleUpload = async (data: any) => {
        if (!data?.selectedFile)
            return enqueueSnackbar('Debe seleccionar un archivo', {
                variant: 'error'
            });
        try {
            setUploadingDocument(true);
            const body: any = {
                nombre: data?.selectedFile?.name?.replace(/ /g, '-'),
                peso: data?.selectedFile?.size,
                idTipoDocumento: data?.tipoDocumento?.id,
                idTipoArchivo: getIdFileExtension(data),
                ...(data?.vencimiento && { vencimiento: data.vencimiento }),
                ...(data?.cuilPropietario && { cuilPropietario: data.cuilPropietario }),
                ...(data?.cuitPropietario && { cuitPropietario: data.cuitPropietario }),
                ...(data?.customId && { customId: data.customId })
            };

            const presignedUrlsByParts: any = await uploadDocumentDataForm(body);
            if (!presignedUrlsByParts?.error) {
                const fetchs: any = [];
                presignedUrlsByParts?.data?.parts?.forEach((part: any, index: number) => {
                    fetchs.push(
                        fetch(part?.signedUrl, {
                            method: 'PUT',
                            headers: {
                                'Content-Type': 'application/octet-stream'
                            },
                            body: fileChunker(data?.selectedFile)[index]
                        })
                    );
                });
                await Promise.all(fetchs);
                const completeUploadFileResponse = await completeUploadFile({
                    docId: presignedUrlsByParts?.data?.idDocumento,
                    uploadId: presignedUrlsByParts?.data?.uploadId
                });
                if (!completeUploadFileResponse?.error) {
                    enqueueSnackbar('Archivo subido correctamente', { variant: 'success' });
                    navigate('/app/consulta-documentos');
                } else {
                    handleErrors(completeUploadFileResponse.error);
                }
            } else {
                handleErrors(presignedUrlsByParts.error);
            }
        } catch (e) {
            enqueueSnackbar('Ocurrió un error al subir el archivo', { variant: 'error' });
        } finally {
            setUploadingDocument(false);
        }
    };

    return {
        handleUpload,
        uploadingDocument
    };
}

export default useUpload;
